exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "th[data-v-1176c0ee]{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:10px}.fade-enter-active[data-v-1176c0ee],.fade-leave-active[data-v-1176c0ee]{-webkit-transition:opacity .5s;transition:opacity .5s}.fade-enter[data-v-1176c0ee],.fade-leave-to[data-v-1176c0ee]{opacity:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1176c0ee","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/vue_lazy_table.vue
// module id = bDXK
// module chunks = 1